export default function BgMadness() {
    return (
      <>
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a3e] via-[#12122b] to-[#0d0d1a] opacity-95 z-0"></div>
  
        {/* Glows */}
        <div className="absolute top-[1%] left-[10%] w-80 h-80 bg-[#00F0FF] opacity-30 rounded-full blur-[80px] animate-pulse z-0"></div>
        <div className="absolute top-[10%] left-[10%] w-80 h-80 bg-[#00F0FF] opacity-30 rounded-full blur-[80px] animate-pulse z-0"></div>
        <div className="absolute top-[30%] left-[60%] w-60 h-60 bg-[#FF007F] opacity-25 rounded-full blur-[70px] animate-flicker z-0"></div>
        <div className="absolute top-[60%] left-[20%] w-48 h-48 bg-[#00FFA2] opacity-20 rounded-full blur-[60px] animate-glitch z-0"></div>
        <div className="absolute top-[75%] left-[70%] w-64 h-64 bg-[#FFD700] opacity-15 rounded-full blur-[90px] animate-glitch z-0"></div>
        <div className="absolute top-[40%] left-[40%] w-72 h-72 bg-[#7F00FF] opacity-20 rounded-full blur-[80px] animate-flicker z-0"></div>
        <div className="absolute top-[85%] left-[10%] w-56 h-56 bg-[#FF4500] opacity-20 rounded-full blur-[70px] animate-pulse z-0"></div>
      </>
    );
  }
  